import React from 'react';
import PropTypes from 'prop-types';
import {
  Icon,
  Menu,
  MenuItem,
  ExpansionPanel,
  ExpansionPanelSummary,
  Typography,
  ExpansionPanelDetails,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { withStyles } from '@material-ui/core/styles';
import { Button } from '../../common';
import { yearChecklistItems, checklistDisplayYear } from '../+store/assessementChecklist/checklistItems';
import styles from './AssessmentChecklist.styles';

const StyledMenu = withStyles({})((props) => <Menu {...props} />);

const StyledExpansionSummary = withStyles({
  root: {
    minHeight: 36,
    // match the flush-left padding of the non-expandable rows so chevron items don't indent
    padding: '0 16px',
    alignItems: 'center',
    '&$expanded': {
      minHeight: 36,
    },
  },
  expanded: {},
  content: {
    // no vertical margin: let the row's minHeight center the label and chevron together
    margin: 0,
    alignItems: 'center',
    '&$expanded': {
      margin: 0,
    },
  },
  expandIcon: {
    padding: 0,
    // MUI v3 positions this icon absolutely with top:50% and relies on
    // translateY(-50%) to re-center it; keep that so the chevron stays inline
    // with the row instead of hanging below it. The rotation makes the
    // disclosure triangle point right when collapsed, down when expanded.
    transform: 'translateY(-50%) rotate(-90deg)',
    '&$expanded': {
      transform: 'translateY(-50%) rotate(0deg)',
    },
  },
})(ExpansionPanelSummary);

class AssessmentChecklist extends React.PureComponent {
  static propTypes = {
    loading: PropTypes.any.isRequired,
    rawCheckList: PropTypes.object,
    classes: PropTypes.any.isRequired,
    initChecklist: PropTypes.func.isRequired,
    profile: PropTypes.any.isRequired,
  };

  state = {
    anchorEl: null,
  };

  componentDidMount() {
    const { initChecklist, profile, loading } = this.props;
    if (profile && !loading) {
      initChecklist(profile);
    }
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  statusIcon = (complete) => {
    const { classes } = this.props;
    return (
      <Icon className={complete ? classes.yesIcon : classes.pendingIcon}>
        {complete ? 'check_circle' : 'radio_button_unchecked'}
      </Icon>
    );
  };

  render() {
    const { rawCheckList, classes } = this.props;
    const { anchorEl } = this.state;
    if (!rawCheckList) {
      return null;
    }
    const year = checklistDisplayYear();
    if (!year || !rawCheckList[year]) {
      return null;
    }
    const items = yearChecklistItems(rawCheckList[year]);
    const roster = rawCheckList.roster || {};
    const rosterDone = !!roster.status;
    const allDone = rosterDone && items.every((item) => item.status);
    return (
      <div className={classes.base}>
        <Button variant="outlined" color="white" onClick={this.handleClick} className={classes.button}>
          <Icon style={{ color: allDone ? '#79f5ab' : '#FFB547', paddingRight: 12 }}>
            {allDone ? 'done' : 'pending_actions'}
          </Icon>
          <Typography>Assessment Checklist</Typography>
        </Button>
        <StyledMenu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={this.handleClose}>
          <MenuItem className={classes.menuItem}>
            <Typography className={classes.header}>
              {year ? `${year} A-F Readiness` : 'Assessment Checklist'}
            </Typography>
          </MenuItem>
          <MenuItem className={classes.menuItem}>
            <div className={classes.row}>
              {this.statusIcon(rosterDone)}
              <Typography>Student Roster{roster.studentsUpdated ? ` (${roster.studentsUpdated})` : ''}</Typography>
            </div>
          </MenuItem>
          {items.map((item) => (
            <MenuItem key={item.key} className={classes.menuItem}>
              {item.children ? (
                <ExpansionPanel className={classes.panel} defaultExpanded={!item.status}>
                  <StyledExpansionSummary expandIcon={<ExpandMoreIcon className={classes.noPadding} />}>
                    {this.statusIcon(item.status)}
                    <Typography className={classes.heading}>{item.label}</Typography>
                  </StyledExpansionSummary>
                  <ExpansionPanelDetails className={classes.sublist}>
                    {item.children.map((child) => (
                      <div className={classes.childRow} key={child.label}>
                        {this.statusIcon(child.status)}
                        <Typography>{child.label}</Typography>
                      </div>
                    ))}
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              ) : (
                <div className={classes.simpleRow}>
                  {this.statusIcon(item.status)}
                  <Typography className={classes.heading}>{item.label}</Typography>
                </div>
              )}
            </MenuItem>
          ))}
        </StyledMenu>
      </div>
    );
  }
}

export default withStyles(styles)(AssessmentChecklist);
